"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var content_parser_1 = require("@dynamynd/content-parser");

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

var enums_1 = require("../../enums");

var index_1 = require("../index");

var getExtraHeightMultiplier = function getExtraHeightMultiplier(activeBreakpoint) {
  if (responsive_1.isExtraLarge(activeBreakpoint)) {
    return 1.2;
  }

  return 1;
};

var SectionInfo = function SectionInfo(_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      height = _a.height,
      width = _a.width,
      toBackgroundColor = _a.toBackgroundColor,
      content = _a.content,
      onLayoutHandler = _a.onLayoutHandler,
      scrollToSectionHandler = _a.scrollToSectionHandler;

  var _b = content_parser_1.parseResultsInfoContent(content),
      titleContent = _b.titleContent,
      firstParagraph = _b.firstParagraph,
      secondParagraph = _b.secondParagraph;

  return react_1.default.createElement(index_1.SectionContainer, {
    backgroundColor: "linear-gradient(180deg, #F6E8D6 0%, #F2CBAD 49.7%, " + toBackgroundColor + " 100%)",
    extraHeightMultiplier: getExtraHeightMultiplier(activeBreakpoint),
    onLayout: function onLayout(event) {
      var infoHeight = event.nativeEvent.layout.height;
      onLayoutHandler(enums_1.ModuleSectionViewsEnum.info, infoHeight);
    }
  }, react_1.default.createElement(index_1.ContentRowResponsive, null, react_1.default.createElement(exports.ImageOwl, {
    screenHeight: height,
    screenWidth: width,
    activeBreakpoint: activeBreakpoint,
    source: {
      uri: components_lib_1.appConfig.layout.owlBackground
    },
    resizeMode: "contain"
  }, react_1.default.createElement(exports.TextContainer, {
    activeBreakpoint: activeBreakpoint
  }, react_1.default.createElement(components_lib_1.Title, {
    centered: true
  }, titleContent), react_1.default.createElement(SectionInfoTextContainer, {
    activeBreakpoint: activeBreakpoint
  }, react_1.default.createElement(components_lib_1.Paragraph, {
    size: components_lib_1.ParagraphSizeEnum.big,
    centered: true
  }, firstParagraph), react_1.default.createElement(components_lib_1.ParagraphWithMargin, {
    size: components_lib_1.ParagraphSizeEnum.big,
    centered: true
  }, secondParagraph))))), react_1.default.createElement(index_1.ScrollDown, {
    scrollToSectionHandler: scrollToSectionHandler
  }));
};

exports.imageOwlMaxHeight = 972;
exports.ImageOwl = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      screenWidth = _a.screenWidth,
      rest = __rest(_a, ["activeBreakpoint", "screenWidth"]);

  return react_1.default.createElement(react_native_1.ImageBackground, __assign({}, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    align-self: stretch;\n    position: relative;\n    max-width: 1003px;\n    max-height: ", "px;\n    min-width: 500px;\n    min-height: 484px;\n    ", ";\n"], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    align-self: stretch;\n    position: relative;\n    max-width: 1003px;\n    max-height: ", "px;\n    min-width: 500px;\n    min-height: 484px;\n    ", ";\n"])), exports.imageOwlMaxHeight, function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      screenWidth = _a.screenWidth;
  return setImageOwlDimensions(activeBreakpoint, screenWidth);
}); // we need this function in ScrollDown

function getImageOwlHeight(activeBreakpoint, screenWidth) {
  var aspect = 1.032;
  var delimiter = calculateDelimiter(activeBreakpoint, screenWidth);
  var width = screenWidth / delimiter;
  var computedHeight = width / aspect;
  return computedHeight < exports.imageOwlMaxHeight ? computedHeight : exports.imageOwlMaxHeight;
}

exports.getImageOwlHeight = getImageOwlHeight;

function setImageOwlDimensions(activeBreakpoint, screenWidth) {
  var aspect = 1.032;
  var delimiter = calculateDelimiter(activeBreakpoint, screenWidth);
  var width = screenWidth / delimiter;
  var height = width / aspect;
  return "\n        width: " + width + "px;\n        height: " + height + "px;\n    ";
}

function calculateDelimiter(activeBreakpoint, screenWidth) {
  if (responsive_1.isExtraLarge(activeBreakpoint)) {
    if (screenWidth < 1400) return 1;
    return 1.6;
  }

  if (responsive_1.isMedium(activeBreakpoint)) {
    return 0.8;
  }

  return 0.3;
}

exports.TextContainer = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    bottom: 14%;\n    left: 50%;\n    ", "\n"], ["\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    bottom: 14%;\n    left: 50%;\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  var small = responsive_1.isSmall(activeBreakpoint);
  var medium = responsive_1.isMedium(activeBreakpoint);
  return "\n            max-width: " + getMaxSize(small, medium) + "px;\n            margin-left: -" + getMaxSize(small, medium) / 2 + "px;\n        ";
});
var SectionInfoTextContainer = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: 0 auto;\n    ", "\n"], ["\n    margin: 0 auto;\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  var small = responsive_1.isSmall(activeBreakpoint);
  var medium = responsive_1.isMedium(activeBreakpoint);
  return "\n            max-width: " + getMaxSize(small, medium) + "px;\n            margin-top: 32px;\n        ";
});

function getMaxSize(small, medium) {
  return small ? 320 : medium ? 360 : 460;
}

exports.default = responsive_1.withResponsiveMeta(SectionInfo);
var templateObject_1, templateObject_2, templateObject_3;